import Config from '@config';
import { initializeMeteringNodeCommercialApi } from '@gasbi/shared/common/features/meteringNodeCommercial';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';

const meteringNodeCommercial = initializeMeteringNodeCommercialApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringNodeCommercialApi,
  useGetMeteringNodesCommercialQuery,
  useCreateMeteringNodeCommercialMutation,
  useGetMeteringNodeByIdCommercialQuery,
  useUpdateMeteringNodeCommercialMutation,
  useGetMeteringNodesCommercialInfiniteQuery,
} = meteringNodeCommercial;
